// @ts-nocheck
import Events from '@/constants/events';

export type CustomError = {
  message: string;
  response?: {
    status?: number;
  };
};

type ErrorSeverity = 'error' | 'log' | 'warn' | 'info';

const DEPLOY_ENV = import.meta.env.MODE || 'prod';

export function handleError(
  err: CustomError,
  severity: ErrorSeverity = 'error',
): void {
  if (err.message === 'Network Error' || err.message === 'Request aborted') {
    window.dispatchEvent(new CustomEvent(Events.Unavailable));
    return;
  }

  if (DEPLOY_ENV !== 'prod') {
    if (severity === 'error') {
      // eslint-disable-next-line no-console
      console.error(err);
    } else {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  }

  if (err.response && err.response.status && err.response.status >= 500) {
    window.dispatchEvent(new CustomEvent(Events.Unavailable));
  }
}
